import { render, staticRenderFns } from "./Addproject.vue?vue&type=template&id=05136034&scoped=true&"
import script from "./Addproject.vue?vue&type=script&lang=js&"
export * from "./Addproject.vue?vue&type=script&lang=js&"
import style0 from "./Addproject.vue?vue&type=style&index=0&id=05136034&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05136034",
  null
  
)

export default component.exports